export default "__VITE_ASSET__CjHhfBeX__"